<template>
  <div v-if="isLandscape" class="landscape-error">
    <p>Play this game in potrait mode.</p>
  </div>
  <div v-else>
    <login v-if="!isRegistered"></login>
    <confirm-user v-else-if="!isConfirmed"></confirm-user>
    <user-details v-else-if ="!showDetails"></user-details>
    <has-error v-else-if="!hasError"> </has-error>
    <has-played v-else-if="!hasPlayed"></has-played>
    <instructions v-else-if="!readInstructions"></instructions>
    <completed v-else-if="isCompleted"></completed>
    <quiz v-else></quiz>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Login from './login.vue';
import ConfirmUser from './confirm.vue';
import Instructions from './instructions.vue';
import Completed from './completed.vue';
import Quiz from './quiz.vue';
import HasPlayed from './hasPlayed';
import HasError from './error';
import UserDetails from './details';

export default {
  name: 'Mobile',
  components: {
    Login,
    ConfirmUser,
    Instructions,
    Completed,
    Quiz,
    HasPlayed,
    HasError,
    UserDetails
  },
  data() {
    return {
      isLandscape: false,
    };
  },
  computed: {
    ...mapGetters(['isRegistered', 'readInstructions', 'isCompleted', 'isConfirmed', 'hasPlayed', 'hasError', 'showDetails']),
  },
  created() {
    window.addEventListener(
      'orientationchange',
      () => {
        // If window.orientation return 0 then potrait
        this.isLandscape = window.orientation !== 0;
      },
      false,
    );
  },
};
</script>

<style lang="scss" scoped>
.landscape-error {
  display: flex;
  width: 100vw;
  align-items: center;
  justify-content: center;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 2;
  cursor: pointer;

  p {
    font-size: 32px;
    line-height: 40px;
    color: $white;
    padding: 1.5rem;
  }
}
</style>
